// extracted by mini-css-extract-plugin
export var addButton = "_gb-0";
export var border = "_gb-8";
export var check = "_gb-h";
export var danger = "_gb-6";
export var dropdownContainer = "_gb-1";
export var editModalBody = "_gb-j";
export var footerContainer = "_gb-i";
export var fullWidth = "_gb-a";
export var hide = "_gb-9";
export var icon = "_gb-3";
export var input = "_gb-7";
export var inputFlex = "_gb-b";
export var inputWrapper = "_gb-c";
export var manualFocus = "_gb-5";
export var optionButton = "_gb-4";
export var pillWrapper = "_gb-e";
export var pointer = "_gb-2";
export var showOverflow = "_gb-f";
export var tagsFlex = "_gb-d";
export var xButton = "_gb-g";